import { ResponsivePie, PieCustomLayerProps } from '@nivo/pie';
import { Box } from '@mui/material';
import { FC } from 'react';

const CenteredMetric: FC<PieCustomLayerProps<PieChartData>> = ({
    dataWithArc,
    centerX,
    centerY,
}) => {
    let total = 0;
    dataWithArc.forEach(datum => {
        total += datum.value;
    });
    let percent = dataWithArc.find(d => d.id === 'centered')!.value;
    let textColor = dataWithArc.find(d => d.id === 'centered')!.color;

    return (
        <text
            x={centerX}
            y={centerY}
            textAnchor="middle"
            dominantBaseline="central"
            fill={textColor || '#202024'}
            style={{
                fontSize: '14px',
                fontWeight: 600,
                fontFamily: [
                    '-apple-system',
                    'BlinkMacSystemFont',
                    'Inter',
                    '"Segoe UI"',
                    '"Helvetica Neue"',
                    'sans-serif',
                ].join(','),
            }}
        >
            {percent}%
        </text>
    );
};

export interface PieChartData {
    value: number;
    centered?: boolean;
    label: string;
    color: string;
    id?: string;
}

export const PieChart: FC<{
    data: PieChartData[];
    [key: string]: any;
}> = ({ data, ...props }) => (
    <ResponsivePie
        data={data}
        margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
        innerRadius={0.6}
        activeOuterRadiusOffset={1}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        colors={{ datum: 'data.color' }}
        layers={['arcs', CenteredMetric]}
        tooltip={({ datum: { value, label } }) => (
            <Box
                style={{
                    fontSize: '12px',
                    padding: '4px 8px',
                    color: '#fcfcfd',
                    background: '#616161E5',
                    borderRadius: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    fontFamily: [
                        '-apple-system',
                        'BlinkMacSystemFont',
                        'Inter',
                        '"Segoe UI"',
                        '"Helvetica Neue"',
                        'sans-serif',
                    ].join(','),
                }}
            >
                <span>{label}</span>
                <strong>{value}%</strong>
            </Box>
        )}
        {...props}
    />
);
